let shippingCountry = document.getElementById("AddressCountry_Shipping");
let countryState = document.getElementById("AddressProvince_shipping");
let shippingCountryZip = document.getElementById("ShippingAddressZip");
let shippingRatePackage = document.querySelector(".shipping_rate_package");
let shippingAddressWrapper = document.querySelector(".shipping_rate_message");
let shippingAddressCount = document.querySelector(".shipping_address_count");
let item = document.querySelector(".shipping_calc_save");
document.querySelectorAll("data-address-country-select");
if (Shopify && Shopify.CountryProvinceSelector) {
  new Shopify.CountryProvinceSelector("AddressCountry_Shipping", "AddressProvince_shipping", {hideElement: "AddressProvinceContainerNewShiping"});
}
item.addEventListener("click", () => {
  shippingRatePackage.innerHTML = "";
  if (shippingCountry.value === "---") {
    shippingAddressWrapper.classList.add("no-js-inline");
    shippingRatePackage.innerHTML = `<p class="error mt-15">${window.shipping.country_label}</p>`;
  } else {
    item.classList.add("loading");
    item.querySelector('.loading-overlay__spinner').classList.remove("hidden");
    fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${shippingCountryZip.value}&shipping_address%5Bcountry%5D=${shippingCountry.value}&shipping_address%5Bprovince%5D=${countryState.value}`).then(response => {
      if (response.ok) {
        return response.json();
      }
      throw `${window.shipping.wrong_message}`;
    }).then(response => {
      item.classList.remove("loading");
      item.querySelector('.loading-overlay__spinner').classList.add("hidden");
      shippingAddressWrapper.classList.remove("no-js-inline");
      shippingAddressCount.innerText = `${response.shipping_rates.length}`;
      response.shipping_rates.map(item2 => {
        let text = document.createElement("P");
        text.setAttribute("class", "mb-0");
        text.innerText = `${item2.name}: ${item2.price}`;
        shippingRatePackage.appendChild(text);
      });
    }).catch(e => {
      item.classList.remove("loading");
      item.querySelector('.loading-overlay__spinner').classList.add("hidden");
      shippingAddressWrapper.classList.add("no-js-inline");
      shippingRatePackage.innerHTML = `<p class="error mt-15">${e}</p>`;
    });
  }
});
